var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, ChevronLeftIcon, Heading, IconButton, Pane, Spinner, ThemeProvider, } from "evergreen-ui";
import { useCallback, useContext, useEffect, useState, } from "react";
import { useHistory, useParams } from "react-router-dom";
import TaskHistory from "../components/TaskHistory";
import TourCard from "../components/TourCard";
import firebase from "../config";
import NavigatorBar from "../container/NavigatorBar";
import { TaskDialogsContext } from "../contexts/TaskDialogsContext";
import theme from "../theme";
export var TourDetails = function (_a) {
    // @ts-ignore ToDo: Type the Dialog context
    var dialogSettings = useContext(TaskDialogsContext).dialogSettings;
    var shownDialog = dialogSettings[0], setShownDialog = dialogSettings[1];
    var push = useHistory().push;
    var _b = useState(null), tour = _b[0], setTour = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    //@ts-ignore
    var tourId = useParams().tourId;
    var getTour = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, firebase
                            .firestore()
                            .collection("tours")
                            .doc(tourId)
                            .get()
                            .then(function (doc) {
                            if (doc.exists) {
                                //@ts-ignore
                                setTour(doc.data());
                            }
                        })
                            .catch(function () { })
                            .finally(function () { return setLoading(false); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [tourId]);
    useEffect(function () {
        getTour();
    }, [getTour]);
    return (
    /* @ts-ignore */
    _jsxs(ThemeProvider, __assign({ value: theme }, { children: [_jsx(TaskHistory, { task: shownDialog.task, isShown: shownDialog.type === "taskHistory", setShown: function () { return setShownDialog({ type: "", task: {} }); } }), _jsxs(Pane, __assign({ style: { display: "flex", flexDirection: "row" } }, { children: [_jsx(NavigatorBar, {}), _jsxs(Pane, __assign({ style: {
                            background: "linear-gradient(-3deg,#E4EBF5 0%, rgba(255,255,255,1) 100%)",
                        }, width: "95vw", height: "100vh", display: "flex", flexDirection: "column", padding: 20 }, { children: [_jsxs(Pane, __assign({ display: "flex", flexDirection: "row", alignItems: "center" }, { children: [_jsx(IconButton, { onClick: function () { return push("/documentation"); }, icon: ChevronLeftIcon }), _jsx(Heading, __assign({ marginLeft: 9 }, { children: "TOUR-DETAILS" }))] })), loading && _jsx(Spinner, {}), tour && !loading && (_jsx(Card, __assign({ marginTop: "20%", elevation: 2, backgroundColor: "white" }, { children: _jsx(TourCard, { tour: tour, hover: false }, "key") })))] }))] }))] })));
};
